import * as ENV from '@partment/env'
import { createClient } from 'contentful'

export function getContentfulClient() {
  if (!ENV.CONTENTFUL_ACCESS_TOKEN) {
    throw new Error(
      'Missing CONTENTFUL_ACCESS_TOKEN environment variable. Ensure it is set in the runtime environment.',
    )
  }
  return createClient({
    space: ENV.CONTENTFUL_SPACE_ID || '',
    accessToken: ENV.CONTENTFUL_ACCESS_TOKEN,
  })
}
